import { InputModel, InputType } from "@husky-hrc/Framework/Types/ApiModel";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Icon from "@insite/mobius/Icon";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import styled, { css } from "styled-components";

export interface InputSubTextStyles {
    wrapper?: InjectableCss;
    textStyles?: TypographyPresentationProps;
    hiddenStyles?: InjectableCss;
    errorMessageStyles?: TypographyPresentationProps;
}

export const inputSubTextStyles: InputSubTextStyles = {
    wrapper: {
        css: css`
            position: absolute;
            left: 0;
            bottom: -24px;
        `,
    },
    textStyles: {
        size: 12,
        lineHeight: "22px",
        css: css`
            letter-spacing: 0.7px;
            color: ${getColor("text.main")};
            opacity: 0.8;
        `,
    },
    hiddenStyles: {
        css: css`
            visibility: hidden;
        `,
    },
    errorMessageStyles: {
        size: 12,
        lineHeight: "22px",
        color: "danger.main",
    },
};

const ErrorContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    svg {
        stroke: ${getColor("common.background")};
        fill: ${getColor("danger.main")};
    }
`;
interface OwnProps {
    input: InputModel;
    errorMessage?: string;
    id?: string;
}

const styles = inputSubTextStyles;

type Props = OwnProps;

const InputSubText = ({ input, errorMessage, id }: Props) => {
    const numberWithRange = input.type === InputType.NUMBER && !Number.isNaN(input.min) && !Number.isNaN(input.max);

    return errorMessage ? (
        <ErrorContainer id={id}>
            <Icon src="AlertCircle" color="danger.main" size={16} />
            <Typography {...styles.errorMessageStyles}>{errorMessage}</Typography>
        </ErrorContainer>
    ) : numberWithRange ? (
        <StyledWrapper {...styles.wrapper}>
            <Typography id={id} {...styles.textStyles}>
                Min: {input.min.toFixed(2)} - Max: {input.max.toFixed(2)}
            </Typography>
        </StyledWrapper>
    ) : (
        <StyledWrapper {...styles.wrapper}>
            <Typography id={id} {...styles.hiddenStyles}>
                &nbsp;
            </Typography>
        </StyledWrapper>
    );
};

export default InputSubText;
